import { CustomDropdownWithSelect } from "Components/CommonComponents/CustomDropdownWithSelect";
import Typography from "Components/CommonComponents/Typography";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card, Col, Collapse, Row, Spinner } from "reactstrap";
import {
  BASE_URL,
  TESTPERFORMANCE,
} from "utilFunctions/Constants/urlConstants";
import "./studentLop.css";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";

import UpArrowIcon from "Assets/Icons/UpArrowIcon";
import DownArrowIcon from "Assets/Icons/DownArrowIcon";
import StudentPerformanceGraph from "Pages/BranchHealth/Student/StudentPerformanceGraph";
import { StudentContext } from "Context/StudentContext";
import StudentWeaknesStrengthComponent from "Pages/StudentPortfolio/StudentLOPSection/StudentWeaknesStrengthComponent";
import StudentLopTable from "Pages/StudentPortfolio/StudentLOPSection/StudentLopTable";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
const tableHeading = [
  { label: "Month", value: "month" },
  { label: "Segment", value: "segment" },
];
export interface filterIFC {
  acadYearState?: {
    label: string;
    value: string;
  };
  testTypeState?: any | null;
  subjectState?: any | null;
}
function StudentLopMain() {
  const location = useLocation();
  const { state } = location;
  const { selectedStudent: ContextStudent } = useContext<any>(StudentContext);
  //   const student = useContext<any>(StudentContext);
  const selectedStudent =
    state &&
    state != null &&
    state?.selectedStudent &&
    state?.selectedStudent != null &&
    state?.selectedStudent.stream
      ? state.selectedStudent
      : ContextStudent;
  const [filterState, setFilterState] = useState<filterIFC>({
    acadYearState: selectedStudent?.academicYear
      ? selectedStudent.academicYear
      : { label: "--select--", value: selectedStudent?.clazz },
    testTypeState: null,
    subjectState: null,
  });
  const [lopTableData, setLopTableData] = useState<any>([]);
  const [showFilter, setShowFilter] = useState<any>(false);
  const [isOpenTestPerformance, setIsOpenTestPerformance] = useState<any>(true);
  const [barArray, setBarArray] = useState<any>([]);
  const { makeRequest, loading, responseData } = useGetApi(
    (data: any) => {
      onSuccess(data);
    },
    (error: any) => {
      onerror(error);
    }
  );
  const onSuccess = (data: any) => {
    console.log(selectedStudent.clazz, "selectedStudent.clazz", data);
  };

  const onerror = (data: any) => {
    console.log("Performance data", data);
  };
  useEffect(() => {
    if (responseData?.data) {
      setLopTableData(responseData?.data);
      const datacopy = [...responseData.data];
      const newArray = datacopy.map((item) => {
        return item.month;
      });
      setBarArray(newArray);
    }
  }, [responseData]);
  useEffect(() => {
    if (selectedStudent?.academicYear) {
      setFilterState({
        acadYearState: selectedStudent?.academicYear
          ? selectedStudent.academicYear
          : { label: "--select--", value: selectedStudent.clazz },
        testTypeState: null,
        subjectState: null,
      });
    }
    console.log(
      barArray,
      selectedStudent,
      selectedStudent?.academicYear,
      "selectedStudent?.selectedYear"
    );
    if (selectedStudent?.psid && selectedStudent.stream) {
      const url =
        BASE_URL +
        "lop/percentageView?" +
        `psid=${selectedStudent.psid}&stream=${selectedStudent.stream}`;
      makeRequest(url);
    }
  }, [selectedStudent?.psid]);
  const toggle = () => setIsOpenTestPerformance(!isOpenTestPerformance);
  const toggltePerformanceVisible = () => {
    setShowFilter(!showFilter);
  };
  const clearAllPerformanceVisible = () => {
    setFilterState({
      acadYearState: selectedStudent?.academicYear
        ? selectedStudent.academicYear
        : { label: "--select--", value: selectedStudent.clazz },
      testTypeState: null,
      subjectState: null,
    });
    toggltePerformanceVisible();
  };

  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
    if (name == "acadYearState") {
      const url =
        BASE_URL +
        TESTPERFORMANCE +
        `psid=${selectedStudent.psid}&clazz=${val.value}&academicYear=${val.label}&stream=${selectedStudent.stream}`;
      makeRequest(url);
      setFilterState((prevState: any) => ({
        ...prevState,
        testTypeState: null,
        subjectState: null,
      }));
    }
  };

  return (
    <div className="mt-3">
      <StudentWeaknesStrengthComponent selectedStudent={selectedStudent} />
      <Card className="p-3">
        <>
          <div className="w-100 d-flex flex-row justify-content-between barGraphHeading">
            <div className="LopStudentnamelegendContainerMain">
              <div className="LopStudentnamelegendContainer">
                <div className="LopStudentnamelegend"></div>
                <Typography variant="forminfo" color="black">
                  {selectedStudent?.name}
                </Typography>
              </div>
              <div className="LopStudentnamelegendContainer">
                <div className="LopStudentnamelegendCls"></div>
                <Typography variant="forminfo" color="black">
                  Class Average
                </Typography>
              </div>
            </div>

            {showFilter ? (
              <>
                <div className="w-50 d-flex flex-row filtersPerformanceDiv justify-content-end">
                  <div>
                    <CustomDropdownWithSelect
                      placeholderLabel="Test Type"
                      placeholder=""
                      width={240}
                      allowSelectAll={true}
                      options={[{ label: "--select--", value: null }]}
                      isSearchableDrop={true}
                      isDropdownSelect={true}
                      isMulti={true}
                      isSearchable={true}
                      isClearable={false}
                      isDisabled={false}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      menuPlacement="bottom"
                      menuShouldScrollIntoView={true}
                      onChange={(selected: any) => {
                        handleAddFilterArrayList("testTypeState", selected);
                      }}
                      value={filterState.testTypeState}
                      data-minimum-results-for-search="Infinity"
                    />
                  </div>
                  <div className="betweenFilter">
                    <CustomDropdownWithSelect
                      placeholderLabel="Subject"
                      placeholder=""
                      width={240}
                      allowSelectAll={true}
                      options={[{ label: "--select--", value: null }]}
                      isMulti={true}
                      isSearchableDrop={true}
                      isDropdownSelect={true}
                      isSearchable={true}
                      isClearable={false}
                      isDisabled={false}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      menuPlacement="bottom"
                      menuShouldScrollIntoView={true}
                      onChange={(selected: any) => {
                        handleAddFilterArrayList("subjectState", selected);
                      }}
                      value={filterState.subjectState}
                      data-minimum-results-for-search="Infinity"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center ml-3"
                    onClick={() => clearAllPerformanceVisible()}
                  >
                    <span className="filterSpan">Reset All</span>
                  </div>
                  <div className="cursorHoverCSS" onClick={toggle}>
                    {isOpenTestPerformance ? (
                      <UpArrowIcon />
                    ) : (
                      <DownArrowIcon />
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="d-flex flex-row">
                {/* <div
                  className="d-flex align-items-center mt-n2"
                  onClick={() => toggltePerformanceVisible()}
                >
                  <span className="filterSpan">Filter</span>
                  <FilterIcon className="cursor-pointer" />
                </div> */}
                <div className="cursorHoverCSS" onClick={toggle}>
                  {isOpenTestPerformance ? <UpArrowIcon /> : <DownArrowIcon />}
                </div>
              </div>
            )}
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100 p-3">
              <Spinner color="info"></Spinner>
            </div>
          ) : (
            <Collapse isOpen={isOpenTestPerformance}>
              {lopTableData && lopTableData.length ? (
                <Row className="">
                  <Col
                    sm="12"
                    md="12"
                    lg="12"
                    className="d-flex flex-row justify-content-start mt-2"
                  >
                    <StudentPerformanceGraph
                      mode="studentlop"
                      barArray={barArray}
                      tableHeading={tableHeading}
                      filterState={filterState}
                      OverallPerformanceArray={lopTableData}
                    />
                    <StudentLopTable
                      tableHeading={tableHeading}
                      tableData={lopTableData}
                      barArray={barArray}
                    />
                  </Col>
                </Row>
              ) : (
                <NoResultFoundSearch
                  primaryMessage="Left out probability not available"
                  secondaryMessage={
                    "The Left Out Probability data is not yet synchronized in the system; we're on it to provide you with comprehensive insights."
                  }
                >
                  <NoDataFoundIcon />
                </NoResultFoundSearch>
              )}
              {/* )} */}
            </Collapse>
          )}
        </>
      </Card>
    </div>
  );
}

export default StudentLopMain;
